export const CHECKOUT_URL = 'https://steal-frame.impultienda.ar/checkout'

export const painPoints = [
  {
    emoji: '🛻',
    text: 'Llegas el primero a la obra y te vas al último, pero el que trae la troca nueva es tu jefe.',
  },
  {
    emoji: '💸',
    text: 'Sabes hacer la mezcla, levantar el muro y tirar la losa mejor que nadie, pero no sabes cuánto cobrar para que te quede utilidad de verdad.',
  },
  {
    emoji: '📉',
    text: 'Te da miedo independizarte porque no sabes cómo hacer un presupuesto real o qué decir cuando el cliente te pide rebaja.',
  },
  {
    emoji: '😫',
    text: 'Sientes que los años se te van en el andamio y tu cuerpo ya está pidiendo esquina.',
  },
]

export const modules = [
  {
    tomo: 'Tomo 1',
    title: 'De Maestro a Dueño',
    text: 'Cómo organizar tu cuadrilla y que el negocio rinda sin que tú tengas que estar pegando ladrillos todo el día.',
  },
  {
    tomo: 'Tomo 2',
    title: 'Sistemas 2026',
    text: 'Steel Frame, Block Celular y sistemas rápidos. ¡Termina las obras en la mitad del tiempo!',
  },
  {
    tomo: 'Tomo 3',
    title: 'Cómputo al Centavo',
    text: 'Que no se te olvide ni el clavo más chico. Si no computas bien, estás regalando tu chamba.',
  },
  {
    tomo: 'Tomo 4',
    title: 'Control de Cuadrillas',
    text: 'Cómo liderar a tu gente para que no te "hagan de chivo los tamales" y la obra avance.',
  },
  {
    tomo: 'Tomo 5',
    title: 'Marketing de Obra',
    text: 'Cómo usar tu celular para que los clientes te busquen a TI y no tú a ellos.',
  },
  {
    tomo: 'Tomo 6',
    title: 'Cierre de Contratos',
    text: 'La psicología para que el cliente te diga que SÍ, aunque no seas el más barato.',
  },
]

export const bonuses = [
  {
    n: 1,
    title: 'La Calculadora Maestra (Excel)',
    text: 'Deja de presupuestar "a ojo". Metes los metros cuadrados y la planilla te dice exactamente cuánto gastar en cemento, varilla y mano de obra. ¡Actualizada con precios de 2026!',
    value: '$1,800 MXN',
  },
  {
    n: 2,
    title: 'Pack de 7 Contratos Blindados',
    text: 'Que no te cuente las muelas el cliente. Contratos listos para imprimir y firmar que te protegen legalmente si no te quieren pagar o si salen imprevistos.',
    value: '$1,500 MXN',
  },
  {
    n: 3,
    title: 'El Checklist de los 150 Puntos',
    text: 'Una lista profesional para revisar tus obras. Úsala para que el cliente vea que eres un experto y que nada se te escapa (cimentación, acabados, plomería).',
    value: '$900 MXN',
  },
  {
    n: 4,
    title: 'Guía para Negociar con Casas de Materiales',
    text: 'Aprende a negociar como los grandes. Cómo conseguir descuentos en el cemento y la varilla para que ese ahorro se vaya directo a TU bolsillo.',
    value: '$800 MXN',
  },
  {
    n: 5,
    title: 'Masterclass "La Psicología del Sí"',
    text: '¿Te da pena cobrar? ¿Te tiembla la voz al dar el precio? Aquí te enseño cómo hablar con seguridad para cerrar contratos High-Ticket y que te respeten como profesional.',
    value: '$1,200 MXN',
  },
]

export const recentBuyers = [
  { name: 'Carlos', place: 'Houston, TX', minutes: 5 },
  { name: 'Miguel Ángel', place: 'Guadalajara, JAL', minutes: 8 },
  { name: 'Ramón', place: 'Miami, FL', minutes: 12 },
  { name: 'Juan Pablo', place: 'Ciudad de México', minutes: 17 },
  { name: 'Chuy', place: 'Dallas, TX', minutes: 21 },
  { name: 'Efraín', place: 'Los Ángeles, CA', minutes: 26 },
  { name: 'Beto', place: 'Monterrey, NL', minutes: 33 },
  { name: 'Lupita', place: 'Orlando, FL', minutes: 38 },
  { name: 'Servando', place: 'Puebla, PUE', minutes: 44 },
  { name: 'Toño', place: 'Austin, TX', minutes: 51 },
  { name: 'Ricardo', place: 'Tijuana, BC', minutes: 58 },
]

export const faqs = [
  {
    q: '¿Necesito saber usar mucho la compu?',
    a: 'No, con que sepas usar WhatsApp y leer PDF en tu cel, ya la armaste.',
  },
  {
    q: '¿Sirve si apenas voy a empezar?',
    a: '¡Es lo mejor! Así empiezas ganando y no perdiendo como la mayoría por no saber cobrar.',
  },
  {
    q: '¿Es seguro el pago?',
    a: '100%. Usamos plataformas seguras que protegen tus datos.',
  },
  {
    q: '¿Cuándo recibo el material?',
    a: 'Descarga inmediata a tu celular o compu al terminar el pago. Aceptamos todas las tarjetas y OXXO.',
  },
]
